import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

//
import CLINICIMG from "../../../assets/images/about-clinic-xatirchi.jpg";
import ImageOverlayCard from "../../../components/image-overlay-card/ImageOverlayCard";

export default function AboutXatirchi() {
  const { t } = useTranslation();
  const historyParagraphs = t("aboutXatirchi").split("\n\n");

  return (
    <StyledAboutXatirchi>
      <div className="container">
        <div className="about-xatirchi__wrap">
          <div className="about-xatirchi__left"></div>
          <div className="about-xatirchi__right">
            <h1>{t("aboutXatirchiTitle")}</h1>
            <div className="about-xatirchi__content">
              {historyParagraphs.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </div>
          </div>
        </div>
      </div>
      <ImageOverlayCard
        className="about-xatirchi__img"
        image={CLINICIMG}
        title={t("locationXatirchi")}
        alt={t("locationXatirchi")}
      />
    </StyledAboutXatirchi>
  );
}

const StyledAboutXatirchi = styled.section`
  position: relative;
  background-color: var(--bg);

  .about-xatirchi {
    &__wrap {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }

    &__right {
      padding: 140px 0 140px 70px;

      h1 {
        margin-bottom: 24px;
        color: var(--title);
        font-size: var(--fs-section-title);
        font-weight: var(--fw-semibold);
        line-height: var(--lh-title);
      }
    }

    &__content {
      display: grid;
      gap: 18px;

      p {
        color: var(--text);
        font-size: var(--fs-body);
        font-style: normal;
        font-weight: var(--fw-regular);
        line-height: var(--lh-body);
        text-align: left;
      }
    }

    &__img {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 50%;
    }
  }
`;
